import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SHARED_MODULES } from '../../../shared.';
import { PhButtonComponent } from '../../components/ph-button/ph-button.component';
import { PhIconComponent } from '../../components/ph-icon/ph-icon.component';

import { IPhModalData, IPhModalButton } from './models/phModalData';
import { IPhModalAnswer } from './models/phModalAnswer';

@Component({
	selector: 'app-ph-modal',
	templateUrl: './ph-modal.component.html',
	styleUrls: ['./ph-modal.component.scss'],
	imports: [SHARED_MODULES, PhIconComponent, PhButtonComponent],
	standalone: true
})
export class PhModalComponent {
	public config: IPhModalData;

	constructor(
		private dialogRef: MatDialogRef<PhModalComponent>,
		@Inject(MAT_DIALOG_DATA) private data: IPhModalData
	) {
		this.config = {
			...data,
			buttons: data?.buttons || []
		};

		this.dialogRef.beforeClosed().subscribe((result: IPhModalAnswer | undefined) => {
			if (result === undefined) this.close();
		});
	}

	public onButtonClick(button: IPhModalButton): void {
		const answer: IPhModalAnswer = { buttonId: button.id };
		this.dialogRef.close(answer);
	}

	public close(): void {
		const answer: IPhModalAnswer = { buttonId: null };
		this.dialogRef.close(answer);
	}
}
